{
  "version": 1,
  "asset_id": "93e34935-7873-490e-be5f-e639f289f7c2",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/93e34935-7873-490e-be5f-e639f289f7c2/lighting-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/93e34935-7873-490e-be5f-e639f289f7c2/lighting-card.webp",
  "original_filename": "lighting-card.webp",
  "size": 13270,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:55Z"
}
